import { Stack, Typography } from '@mui/material';
import type { TemplatingContextType } from '@tyro/api';
import { IconButtonWithTooltip } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { NewTemplateIcon } from '@tyro/icons';
import type { Dispatch, SetStateAction } from 'react';

interface InsertTemplateButtonProps {
  onOpenChange: Dispatch<SetStateAction<boolean>>;
  contextType: TemplatingContextType | undefined;
  isFullScreen?: boolean;
}

export function InsertTemplateButton({
  onOpenChange,
  contextType,
  isFullScreen,
}: InsertTemplateButtonProps) {
  const { t } = useTranslation(['mail']);

  return (
    <Stack justifyContent="center" alignItems="center">
      <IconButtonWithTooltip
        title={
          contextType
            ? t('mail:insertTemplate')
            : t('mail:insertTemplateTooltip')
        }
        placement="top"
        onClick={() => {
          onOpenChange(true);
        }}
        disabled={!contextType}
      >
        <NewTemplateIcon />
      </IconButtonWithTooltip>
      {isFullScreen && (
        <Typography variant="caption" fontSize="10px">
          {t('mail:template')}
        </Typography>
      )}
    </Stack>
  );
}
